import { useEffect } from 'react';
import useDocumentTitle from '../../../../a11y/hooks/useDocumentTitle';
import gaPageView from './gaPageView';

/**
 * Use this component to log to Google Analytics for a report pages
 * @param {*} param0 
 * @returns 
 */
export default function ReportAnalytics(props) {
  const { path, title, children } = props;

  useDocumentTitle(title);
  
  useEffect(() => {
    if(path && title){
      gaPageView(path, title);
    }
  }, [path, title]);

  if (children) {
    return children;
  }
  return null;
}